
import { defineComponent, reactive } from 'vue'
import LogoutModal from '@/views/modal/LogoutModal.vue'

interface State {
  showingDialog: boolean;
}

export default defineComponent({
  components: {
    LogoutModal
  },
  setup () {
    const state = reactive<State>({
      showingDialog: false
    })

    return {
      state
    }
  }
})
